export default defineNuxtPlugin(() => {
    const { logout } = useDirectusAuth()
    const { refreshTokens } = useDirectusToken();
    const router = useRouter()
    const user = useDirectusUser()

    if (!user.value) return


    const interval = setInterval(async () => {
        try {
            // Le refresh est idempotent -> on peut le rejouer sans risque.
            await withRetry(() => refreshTokens())
            console.log('[🔁] Token refreshed')
        } catch (err) {
            // Session reellement invalide -> deconnexion (comportement d'origine).
            if (isAuthError(err)) {
                console.warn('[⚠️] Token refresh failed (auth). Logging out...', err)
                clearInterval(interval)
                await logout()
                router.push('/login')
                return
            }
            // 503 / reseau : la session est VALIDE. On ne deconnecte pas, et on ne
            // tue pas l'intervalle — le cycle suivant reessaiera dans 13 min.
            console.error('[⚠️] Token refresh failed (transient), session conservee:', err)
        }
    }, 13 * 60 * 1000) // 13 minutes
})
